import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import Header from 'components/Header';
import RouteApp from 'domains/Routes/application/route_app';
import { ProjectAPI } from 'domains/Project/infrastructure';
import { CircularProgress } from '@material-ui/core';
import { updateInitApp, updateSending, resetState, showNotify, updateProjects, updateProjectsStatus } from 'vendor/application/disptach';

import PropTypes from 'prop-types';

class App extends Component {
    constructor(props) {
        super(props);
        this.getAllProjects = this.getAllProjects.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(updateSending(false));
        this.getAllProjects();
    }

    async getAllProjects() {
        const { access } = this.props.data;
        if (access.isAccess) {
            try {
                let obj = new ProjectAPI(null, access, this.props);
                const projects = await obj.get_projects();

                this.props.dispatch(updateProjects(projects));
                this.props.dispatch(updateInitApp(true));
                this.props.dispatch(updateProjectsStatus(false));
            } catch (err) {
                const data = { message: err, severity: 'error' };
                this.props.dispatch(showNotify(data));
            }
        } else {
            this.props.dispatch(resetState())
        }
    }

    render() {
        const { initApp } = this.props.data;
        return (
            <div className="a-app">
                <div className="a-container">
                    {
                        initApp ?
                            <React.Fragment>
                                <Header shutDown={this.props.shutDown}/>
                                <RouteApp getAllProjects={this.getAllProjects}/>
                            </React.Fragment>
                            :
                            <div className="a-init">
                                <CircularProgress color="secondary" />
                            </div>
                    }

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    }
}

const connect_app = connect(
    mapStateToProps
)(App);

App.propTypes = {
    shutDown: PropTypes.func,
    data: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired
};

export default withRouter(connect_app);